import { Component, ViewChild, ElementRef, OnInit } from '@angular/core';

@Component({
	selector: 'drag-selector',
	templateUrl: './drag-selector.component.html',
	styleUrls: ['./drag-selector.component.scss'],
})

// draws a selection box on div - TODO make into a shared component
export class DragSelectorComponent implements OnInit {
	@ViewChild('canvas', { static: true }) canvas: ElementRef;

	private ctx: CanvasRenderingContext2D;
	private drag: boolean;
	private rect: any;

	constructor(private el: ElementRef) {
	}

	ngOnInit() {
		this.ctx = this.canvas.nativeElement.getContext('2d');
		this.drag = false;
		this.rect = {};
	}

	onMouseDown(e: MouseEvent): void {
		this.rect.startX = e.pageX - this.el.nativeElement.offsetLeft;
		this.rect.startY = e.pageY - this.el.nativeElement.offsetTop;
		this.drag = true;
	}
	onMouseMove(e: MouseEvent): void {
		if (this.drag) {
			this.rect.w = (e.pageX - this.el.nativeElement.offsetLeft) - this.rect.startX;
			this.rect.h = (e.pageY - this.el.nativeElement.offsetTop) - this.rect.startY;
			this.ctx.clearRect(0, 0, this.canvas.nativeElement.width, this.canvas.nativeElement.height);
			this.ctx.fillRect(this.rect.startX, this.rect.startY, this.rect.w, this.rect.h);
		}
	}
	onMouseUp(e: MouseEvent): void {
		this.drag = false;
	}
}
